import { z } from 'zod';
import { DEFAULT_LEDGER_PAGE_SIZE, OPERATION_KIND_FILTERS } from './-constants';
export const AttendanceClosingLedgerSearchSchema = z.object({
  freeText: z.string().default(''),
  /**
   * 業務の系統でのフィルタタブ。URL から未知の値が来ても台帳が空にならないよう
   * `all` へ倒す（タブは表示の切り替えであって、絞り込みの失敗を見せる場所ではない）。
   * 取りうる値は `-constants.ts` の `OPERATION_KIND_FILTERS` が単一ソース。
   */
  operationKind: z.enum(OPERATION_KIND_FILTERS).catch('all').default('all'),
  /**
   * ページング値は URL から直接与えられるため、範囲を絞ってから使う。
   * `pageSize: 0` は総ページ数を Infinity にし、負の `pageIndex` は `slice` を
   * 空振りさせるため、どちらも一覧が空になる。不正値は既定値へ倒す
   * （throw するとルート自体がエラーになり、壊れ方が悪化する）。
   */
  pageIndex: z.number().int().nonnegative().catch(0).default(0),
  pageSize: z.number().int().positive().catch(DEFAULT_LEDGER_PAGE_SIZE).default(DEFAULT_LEDGER_PAGE_SIZE)
});
export type AttendanceClosingLedgerSearchParams = z.infer<typeof AttendanceClosingLedgerSearchSchema>;